module.exports = __webpack_public_path__ + "static/media/08fa-prime.03f0ed23.jpg";